import { breakpoints, useMediaQuery } from '@coursera/cds-core';

const useIsTablet = (): boolean => {
  const tabletBreakpoint = breakpoints.down('sm');
  const isTablet = useMediaQuery(tabletBreakpoint);

  return isTablet;
};

export default useIsTablet;
